import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Home from '@/pages/home/page';
import Categories from '@/pages/categories/page';
import Articles from '@/pages/articles/page';
import ArticleDetail from '@/pages/articles/detail/page';
import About from '@/pages/about/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/categories',
        element: <Categories />,
      },
      {
        path: '/articles',
        element: <Articles />,
      },
      {
        path: '/articles/:id',
        element: <ArticleDetail />,
      },
      {
        path: '/about',
        element: <About />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;